import { Group, Paper, Text } from '@mantine/core'
import type { KeyDataItem } from '../../../types/keyDataItem'
import { ActionIcon } from '../../Common/ActionIcon'

export type KeyDataRowProps = KeyDataItem

function getDisplayValue(value: string | null): { text: string; color?: string; italic?: boolean } {
  if (value == null) return { text: 'No Record', color: 'brand.7', italic: true }
  if (value === '') return { text: 'N/A', color: 'brand.7' }
  return { text: value }
}

export function KeyDataRow({
  label,
  value,
  actionIcon,
  actionIconSize = 'sm',
  onActionClick,
}: Readonly<KeyDataRowProps>) {
  const display = getDisplayValue(value)
  const showAction = Boolean(actionIcon && onActionClick)

  return (
    <Paper withBorder p="xs" shadow="xs">
      <Group justify="space-between" align="center" wrap="nowrap" gap="xs">
        <Text fz="xs" fw="var(--mantine-font-weight-semibold)" style={{ whiteSpace: 'nowrap' }}>
          {label}:
        </Text>
        <Text fz="xs" truncate c={display.color} fs={display.italic ? 'italic' : undefined}>
          {display.text}
        </Text>
        {showAction && <ActionIcon icon={actionIcon} iconSize={actionIconSize} onClick={onActionClick!} />}
      </Group>
    </Paper>
  )
}
